import { Component } from '@angular/core';
import { SessionService } from '../../../services/session.service';

@Component({
    selector: 'app-login',
    standalone: true,
    templateUrl: './login.component.html',
    styleUrl: './login.component.css'
})
export class LoginComponent {
    constructor(private readonly sessionService: SessionService) { }

    signIn(): void {
        this.sessionService.signIn().subscribe();
    }
}
